if (!customElements.get('filter-form')) {
  customElements.define(
    'filter-form',
    class FilterForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.clearButton = this.querySelector('.filter__reset');
        this.clearButton.addEventListener('click', this.onResetHandler.bind(this));
        this.inputs = this.querySelectorAll('.flt__input');
        this.ranges = this.querySelectorAll('.flt__input[type="range"');
        this.slider = this.querySelector('.price-slider');
        this.slidermin = this.querySelector('.range-min');
        this.slidermax = this.querySelector('.range-max');
        this.sort = this.querySelector('.flt__input[type="radio"]');
        let that = this;
        this.inputs.forEach(function (e) {
          e.addEventListener('change', that.onChangeFilter.bind(that));
        });
        rangeBar();
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const params = new URLSearchParams(formData);
        var url = window.location.href.split('?')[0] + '/?' + params.toString();
        document.querySelector('body').classList.add('filtering');
        nextPage = false;
        nextContentFiltered(url);
      }

      onResetHandler(evt) {
        evt.preventDefault();

        this.handleErrorMessage();
        this.inputs.forEach(function (e) {
          e.checked = false;
        });
        this.ranges[0].value = 0;
        let rmax = this.ranges[1].getAttribute('max');
        this.ranges[1].value = rmax;
        this.slider.style.left = 0;
        this.slider.style.right = 0;
        this.slidermin.value = 0;
        this.slidermax.value = parseInt(rmax) * 0.01;
        this.sort.checked = true;

        var url = window.location.href.split('?')[0];
        document.querySelector('body').classList.add('filtering');
        document.querySelector('.filter__reset').classList.add('clean');
        nextPage = false;
        nextContentFiltered(url);
      }

      onChangeFilter(evt) {
        evt.preventDefault();
        
        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const params = new URLSearchParams(formData);
        var url = window.location.href.split('?')[0] + '/?' + params.toString();
        document.querySelector('body').classList.add('filtering');
        document.querySelector('.filter__reset').classList.remove('clean');

        nextPage = false;
        nextContentFiltered(url, evt.target.type);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.filter-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.filter-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

async function nextContentFiltered(url,type) {
  setTimeout(function () {
    window.scrollTo({ top: 0 });
  }, 200);
  try {
    // Realizar la solicitud fetch
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }

    // Obtener el texto de la respuesta
    const htmlText = await response.text();

    // Usar una expresión regular para extraer el contenido entre los comentarios <!-- ajax -->
    const ajaxContent = htmlText.match(/<!-- ajax -->([\s\S]*?)<!-- ajax -->/i);

    // Verificar si se encontró el contenido
    if (ajaxContent && ajaxContent[1]) {
      // Crear un contenedor temporal para el contenido extraído
      const tempDiv = document.createElement('div');
      tempDiv.classList.add('collection__grid');
      tempDiv.innerHTML = ajaxContent[1];

      // Agregar el contenido extraído al body
      document.querySelector('.collection__container').innerHTML = '';
      document.querySelector('.collection__container').appendChild(tempDiv);
      document.querySelectorAll('article').forEach(function (e) {
        let h = e.getBoundingClientRect().top;
        if (h < window.innerHeight) {
          e.classList.add('show');
        }
      });
      document.querySelector('body').classList.remove('filtering');
      /*if(type != 'range'){
        let range =findMinMaxPrice();
        document.querySelector('input[name="filter.v.price.gte"]').value=range[0]/100;
        document.querySelector('input[name="filter.v.price.lte"]').value=range[1]/100;
        document.querySelectorAll('.range-input .flt__input').forEach(function(item, i){
                item.setAttribute('min', range[0]);
                item.setAttribute('max', range[1]);
                if(i==0){item.value=range[0]}else{item.value=range[1]}
        })
      }*/
      nextPage = true;
    } else {
      console.error('No se encontró contenido entre los comentarios <!-- ajax -->');
    }
  } catch (error) {
    console.error('Error al realizar la solicitud fetch:', error);
  }
}

function findMinMaxPrice() {
    const salePriceInputs = document.getElementsByName("salePrice");
    const values = Array.from(salePriceInputs).map(input => Number(input.value));
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    // Mostrar los resultados
    return [minValue, maxValue];
}

function rangeBar(min,max){
    console.log(min);
  min = (min)?min:0;  
  const rangevalue = document.querySelector('.slider-container .price-slider');
  const rangeInputvalue = document.querySelectorAll('.range-input input');

  // Set the price gap
  let priceGap = 10;

  // Adding event listners to price input elements
  const priceInputvalue = document.querySelectorAll('.price-input input');
  let minVal = parseInt(rangeInputvalue[0].value);
  let maxVal = parseInt(rangeInputvalue[1].value);
  rangevalue.style.left = `${(minVal / rangeInputvalue[0].max) * 100}%`;
  rangevalue.style.right = `${100 - (maxVal / rangeInputvalue[1].max) * 100}%`;


  for (let i = 0; i < priceInputvalue.length; i++) {
   
    priceInputvalue[i].addEventListener('input', (e) => {
      // Parse min and max values of the range input

      let minp = parseInt(priceInputvalue[0].value);
      let maxp = parseInt(priceInputvalue[1].value);
      let diff = maxp - minp;
        console.log(minp, maxp);
      if (minp < 0) {
        alert('minimum price cannot be less than 0');
        priceInputvalue[0].value = 0;
        minp = 0;
      }

      // Validate the input values
      if (maxp > 10000) {
        alert('maximum price cannot be greater than 10000');
        priceInputvalue[1].value = 10000;
        maxp = 10000;
      }

      if (minp > maxp - priceGap) {
        priceInputvalue[0].value = maxp - priceGap;
        minp = maxp - priceGap;

        if (minp < 0) {
          priceInputvalue[0].value = 0;
          minp = 0;
        }
      }

      // Check if the price gap is met
      // and max price is within the range
      if (diff >= priceGap && maxp <= rangeInputvalue[1].max) {
        if (e.target.className === 'min-input') {
          rangeInputvalue[0].value = minp;
          let value1 = rangeInputvalue[0].max;
          rangevalue.style.left = `${(minp / value1) * 100}%`;
        } else {
          rangeInputvalue[1].value = maxp;
          let value2 = rangeInputvalue[1].max;
          rangevalue.style.right = `${100 - (maxp / value2) * 100}%`;
        }
      }
    });

    // Add event listeners to range input elements
    for (let i = 0; i < rangeInputvalue.length; i++) {
      rangeInputvalue[i].addEventListener('input', (e) => {
        let minVal = parseInt(rangeInputvalue[0].value);
        let maxVal = parseInt(rangeInputvalue[1].value);

        let diff = maxVal - minVal;

        // Check if the price gap is exceeded
        if (diff < priceGap) {
          // Check if the input is the min range input
          if (e.target.className === 'min-range') {
            rangeInputvalue[0].value = maxVal - priceGap;
          } else {
            rangeInputvalue[1].value = minVal + priceGap;
          }
        } else {
          // Update price inputs and range progress
          priceInputvalue[0].value = minVal / 100;
          priceInputvalue[1].value = maxVal / 100;
          console.log(minVal-min, rangeInputvalue[0].max)
          rangevalue.style.left = `${(minVal / (rangeInputvalue[0].max)) * 100}%`;
          rangevalue.style.right = `${100 - (maxVal / rangeInputvalue[1].max) * 100}%`;
        }
      });
    }
  }
}